export default "__VITE_ASSET__DgMwHM0a__"